export interface Subject {
  id: string
  name: string
  code: string
  enrolled: number
  teacher: string
  teacherAvatar: string
  icon: string
  color: string
  description: string
}

export const teachers = [
  "Mr. Okafor",
  "Ms. Balogun",
  "Mr. Chukwuma",
  "Mrs. Danjuma",
  "Mr. Ibrahim",
  "Mrs. Adesanya",
  "Mr. Yusuf",
  "Ms. Eze",
]

export const initialSubjects: Subject[] = [
  {
    id: "1",
    name: "Mathematics",
    code: "MTH-101",
    enrolled: 120,
    teacher: "Mr. Okafor",
    teacherAvatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Okafor",
    icon: "calculator",
    color: "orange",
    description: "Basic & Advanced Mathematics including Algebra, Geometry, and Calculus",
  },
  {
    id: "2",
    name: "English Language",
    code: "ENG-101",
    enrolled: 115,
    teacher: "Ms. Balogun",
    teacherAvatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Balogun",
    icon: "languages",
    color: "purple",
    description: "Grammar, Literature, and Comprehension skills",
  },
  {
    id: "3",
    name: "Agricultural Science",
    code: "AGR-202",
    enrolled: 98,
    teacher: "Mr. Chukwuma",
    teacherAvatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Chukwuma",
    icon: "sprout",
    color: "green",
    description: "Practical & Theory in crop production, animal husbandry, and farm management",
  },
  {
    id: "4",
    name: "Civic Education",
    code: "CIV-105",
    enrolled: 118,
    teacher: "Mrs. Danjuma",
    teacherAvatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Danjuma",
    icon: "globe-2",
    color: "pink",
    description: "National Values, Citizenship, and Democratic Education",
  },
  {
    id: "5",
    name: "Basic Science",
    code: "SCI-103",
    enrolled: 110,
    teacher: "Mr. Ibrahim",
    teacherAvatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Ibrahim",
    icon: "microscope",
    color: "blue",
    description: "Introduction to Physics, Chemistry, and Biology",
  },
  {
    id: "6",
    name: "Yoruba Language",
    code: "YOR-101",
    enrolled: 85,
    teacher: "Mrs. Adesanya",
    teacherAvatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Adesanya",
    icon: "message-circle",
    color: "amber",
    description: "Yoruba language, literature, and cultural studies",
  },
  {
    id: "7",
    name: "Computer Studies",
    code: "COM-104",
    enrolled: 105,
    teacher: "Mr. Yusuf",
    teacherAvatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Yusuf",
    icon: "computer",
    color: "indigo",
    description: "Basic computing, programming, and digital literacy",
  },
  {
    id: "8",
    name: "Physical Education",
    code: "PHE-102",
    enrolled: 125,
    teacher: "Ms. Eze",
    teacherAvatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Eze",
    icon: "dumbbell",
    color: "red",
    description: "Sports, fitness, and health education",
  },
]
